import { OnPremDatabaseOutput, OnPremPhysicalServer } from '@amzn/awscat-portfolio-assessment-types';

import { defaultSortBy } from '../../../../common/defaultTableSortState';
import { constants } from '../../../../common/Localization';
import AWSCATTable from '../../../../common/table/Table-index';
import { ColumnDefinition, ColumnTypes } from '../../../../common/table/types';
import { commonResourceDetailColumns } from '../../common/Common';
import { CommonResourceDetailTableItem } from '../../common/types';
import { basicPhysicalServerColumns } from '../OnPremisesHelper';

type OnPremDatabasePhysicalServer = OnPremPhysicalServer & { databaseId: string };
const physicalServerDatabaseCostColumns = (currency: string): ColumnDefinition<OnPremDatabasePhysicalServer>[] => {
    const basicColumns = basicPhysicalServerColumns(currency);
    basicColumns.unshift({
        id: 'databaseId',
        header: constants.DATABASE_ID,
        cell: (item: OnPremDatabasePhysicalServer) => item.databaseId,
        type: ColumnTypes.TEXT,
        text: constants.DATABASE_ID,
    });
    return basicColumns;
};

export const OnPremDatabasePhysicalServerTable = (items: OnPremDatabasePhysicalServer[], currency: string): JSX.Element => {
    return (
        <AWSCATTable
            resourceName={constants.PHYSICAL_SERVERS_TYPE}
            items={items}
            columnDefinitions={physicalServerDatabaseCostColumns(currency)}
            defaultSortBy={defaultSortBy('databaseId')}
            autoGenerateVisibleContent
            enableAutoSorting
            useDefaultDownload
        />
    );
};

export const OnPremDatabaseLicenseTable = (databaseLicenseCost: OnPremDatabaseOutput['databaseLicenseCost']['licenseCost'],
    currency: string): JSX.Element => {

    const onPremDatabaseLicenseItems: CommonResourceDetailTableItem[] = databaseLicenseCost.map(
        license => ({
            resource: license.license,
            unit: license.count,
            totalCost: license.cost + license.supportCost,
        }));

    return (
        <AWSCATTable
            resourceName={constants.DATABASE_SOFTWARE_AND_LICENSES}
            items={onPremDatabaseLicenseItems}
            columnDefinitions={commonResourceDetailColumns(currency)}
            useDefaultDownload
            defaultPageSize={25}
            autoGenerateVisibleContent
        />
    );
};
